module.exports = __webpack_public_path__ + "img/item.5f10c5ee.png";